import { Injectable } from '@angular/core';

import { environment } from '../../environments/environment';

@Injectable()
export class ValConfigService {
  private readonly _baseUrl = environment.scheme + environment.host + environment.port + '/api' + (environment.version ? '/v' + environment.version : '') + '/';
  private readonly _baseUrlMock = './assets/mock-data/';
  public readonly tokenUrl = this._baseUrl + 'account/login';
  public readonly userCashRegistersApiUrl = this._baseUrl + 'account/usercashregisters';
  public readonly forgotPasswordApiUrl = this._baseUrl + 'account/getpass';
  public readonly categoriesLookupUrl = this._baseUrl + 'merchandise/partnercategory';
  public readonly posLookupUrl = this._baseUrl + 'lookup/pos';
  public readonly queryApiUrl = this._baseUrl + 'merchandise/query';
  public readonly singleRecordApiUrl = this._baseUrl + 'merchandise';
  public readonly searchApiUrl = this._baseUrl + 'merchandise/search';
  public readonly pricesApiUrl = this._baseUrl + 'merchandise/prices';
  public readonly priceApiUrl = this._baseUrl + 'merchandise/price';
  public readonly deliveryOptionsApiUrl = this._baseUrl + 'shipment/deliveryoptions';
  public readonly deliveryTypesApiUrl = this._baseUrl + 'merchandise/deliverytypes';
  public readonly regionApiUrl = this._baseUrl + 'merchandise/regions';
  public readonly warehousesApiUrl = this._baseUrl + 'merchandise/warehouses';
  public readonly companyUrl = this._baseUrl + 'user/companyinfo';
  public readonly cartApiUrl = this._baseUrl + 'cart';
  public readonly finalizeApiUrl = this._baseUrl + 'cart/finalize';
  public readonly historyOrdersUrl = this._baseUrl + 'cart/carts';
  public readonly historyInvoicesUrl = this._baseUrl + 'invoice/page';
  public readonly invoiceDetailsUrl = this._baseUrl + 'invoice/details';
  public readonly historyDeliveriesUrl = this._baseUrlMock + 'history.json';
  public readonly pswrdUrl = this._baseUrl + 'account/changepass';
  public readonly userinfoUrl = this._baseUrl + 'account/userinfo';
}
